/**
 * Хранилище токенов. Веб больше не работает на cookie — сессия держится на паре токенов:
 *
 *   токен доступа — сутки, уходит в заголовке Authorization: Bearer <token>;
 *   refresh-токен — полгода, ОДНОРАЗОВЫЙ: обменял → и он, и токен доступа мертвы,
 *                   в ответ приходит новая пара (см. backend Core\Auth).
 *
 * Пары две и они независимы: житель и админ — разные сессии, и человек может быть
 * залогинен обеими одновременно (в legacy это давали две разные cookie).
 *
 * Хранится в localStorage, чтобы сессия переживала перезагрузку вкладки. Это осознанный
 * размен: httpOnly-cookie не украсть скриптом, а localStorage — можно, если на страницу
 * попадёт чужой JS. Взамен refresh одноразовый, и повторное использование украденного
 * гасит всю цепочку сессий — вор получает максимум один короткий заход, а хозяин
 * немедленно оказывается на странице входа и понимает, что что-то не так.
 */

export type TokenKind = 'user' | 'admin'

export interface TokenPair {
  token: string
  refresh_token: string
  expires_in?: number
}

const KEYS: Record<TokenKind, { token: string; refresh: string }> = {
  user: { token: 'rw_user_token', refresh: 'rw_user_refresh' },
  admin: { token: 'rw_admin_token', refresh: 'rw_admin_refresh' },
}

export function getToken(kind: TokenKind): string | null {
  return localStorage.getItem(KEYS[kind].token)
}

export function getRefreshToken(kind: TokenKind): string | null {
  return localStorage.getItem(KEYS[kind].refresh)
}

export function saveTokens(kind: TokenKind, pair: TokenPair): void {
  localStorage.setItem(KEYS[kind].token, pair.token)
  localStorage.setItem(KEYS[kind].refresh, pair.refresh_token)
}

export function clearTokens(kind: TokenKind): void {
  localStorage.removeItem(KEYS[kind].token)
  localStorage.removeItem(KEYS[kind].refresh)
}

export function hasSession(kind: TokenKind): boolean {
  return getToken(kind) !== null
}

/**
 * Какой парой подписывать запрос.
 *
 * Запросы админки (/api/admin/*) — только админской. Всё остальное — жительской;
 * но легаси-пути /docs/get и /getpdfinvoice открывает и админ (из карточки участка),
 * а жительского токена у него нет — тогда берём админский. На бекенде эти два пути
 * помечены auth='user_or_admin' и принимают любую из сессий.
 */
export function kindForPath(path: string): TokenKind | null {
  if (path.startsWith('/api/admin')) return 'admin'
  if (hasSession('user')) return 'user'
  if (hasSession('admin')) return 'admin'
  return null
}
